
    var swiper = new Swiper('.swiper-container-Ourlook', {
      slidesPerView: 'auto',
      spaceBetween: 45,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    var swiper_announcement = new Swiper('.swiper-container-announcement', {
       loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    var swiper_products = new Swiper('.products_slider .swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 0,
          loop: true,
           navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
      
  setTimeout(
    function() 
    {
    var swiper_recommendations  = new Swiper('.swiper-container.recommendation', {
        slidesPerView: 'auto',
        spaceBetween: 0,
            loop: true,
             navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }, 
    });    
  }, 5000);
 

/* Ziv Script Oct 24, 2023 */

function isMobileDevice() {
  return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('Mobile') !== -1);
}

$(document).ready(function() {

  // Create a hover event over the hostspot button in the Timeless Design only on desktop
  if (!isMobileDevice()){
    if ($('.lg-hotspot__button').length > 0){
      $('.lg-hotspot__button').each(function(indx, val){
        //$(val).on('mouseenter', function(){$(val).trigger('click')});
        //$(val).on('mouseleave', function(){$(val).trigger('click')});
      });
    }  
  }
  
});



// Find the checkbox element
let template = theme.routes.template;
let addOnCheckbox = document.getElementById('gift_wrapping_check');
let giftSuccess = document.querySelector(".gift-success-message");
let addOnVariantId;
// Add an event listener to react to changes in the checkbox status
if(addOnCheckbox){
addOnCheckbox.addEventListener('change', function() {
    if (this.checked) {
      if(giftSuccess) giftSuccess.classList.add("show");
        addOnVariantId = this.getAttribute('variant_id');
        console.log("Variant ID:", addOnVariantId);

        // Call addToCart and chain with updateCart if adding to cart was successful
        addToCart(addOnVariantId, 1)
            .then(response => {
                if (response.ok) {
                    console.log("Product added to cart.");
                    return updateCart(addOnVariantId, 1);
                } else {
                    console.error("Failed to add product to cart.");
                }
            })
            .then(cartResponse => {
                if (cartResponse.ok) {
                    console.log("Cart updated successfully.");
                } else {
                    console.error("Failed to update cart.");
                }
            })
            .catch(error => {
                console.error("Error adding product to cart or updating cart:", error);
            });
    } else {
        console.log("Checkbox is unchecked.");
       addOnVariantId = this.getAttribute('variant_id');
      console.log(addOnVariantId);
      
        // If checkbox is unchecked, remove the product from the cart
        if (addOnVariantId) {
            updateCart(addOnVariantId, 0)
                .then(response => {
                    if (response.ok) {
                        console.log("Product removed from cart.");
                    } else {
                        console.error("Failed to remove product from cart.");
                    }
                })
                .catch(error => {
                    console.error("Error removing product from cart:", error);
                });
        }
    }
});

function addToCart(variantId, quantity) {
    return fetch("/cart/add.js", { 
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, 
        body: `id=${variantId}&quantity=${quantity}` 
    });
}

function updateCart(variantId, quantity) {
    return fetch("/cart/update.js", { 
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, 
        body: `updates[${variantId}]=${quantity}` 
    });
}

}

const addGiftNoteCheckbox = document.querySelector('#add-gift-note'); // assuming add-gift-note is an id
const giftNoteTextarea = document.querySelector('#gift-note'); // assuming gift-note is an id

if (addGiftNoteCheckbox && giftNoteTextarea) {
    addGiftNoteCheckbox.addEventListener('change', function() {
        if (this.checked) {
            giftNoteTextarea.classList.add('show');
            if(giftSuccess) giftSuccess.classList.add("show");
        } else {
            giftNoteTextarea.classList.remove('show');
        }
    });
}
// Find the checkbox elements


// // Function to handle checkbox changes
// function handleCheckboxChange() {
//     if (!addGiftNoteCheckbox.checked && !addOnCheckbox.checked) {
//         giftSuccess.classList.remove("show");
//     } else {
//         giftSuccess.classList.add("show");
//     }
// }

// // Add event listeners to both checkboxes
// if (addGiftNoteCheckbox) {
//     addGiftNoteCheckbox.addEventListener('change', handleCheckboxChange);
// }

// if (addOnCheckbox) {
//     addOnCheckbox.addEventListener('change', handleCheckboxChange);
// }




